import { render } from "./doctorprofile.vue?vue&type=template&id=e13ed578"
import script from "./doctorprofile.vue?vue&type=script&lang=js"
export * from "./doctorprofile.vue?vue&type=script&lang=js"

import "./doctorprofile.vue?vue&type=style&index=0&id=e13ed578&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__